<template>
    <div></div>
</template>

<script>
import Toaster from "@/mixins/Toaster/Toaster";

export default {
    name: "Alert",
    mixins: [Toaster],
    computed: {
        alert() {
            const alert = this.$store.getters.getAlert;
            return alert;
        }
    },
    watch: {
        alert: {
            handler(value) {
                this.makeToast(value.heading, value.text, "danger");
            },
            deep: true
        }
    }
};
</script>